import { makeObservable, observable } from "mobx";
import { AppointmentListingModel } from "../AppointmentListingModel";
export interface IAppointmentFlowLaneCard {
    appointment: AppointmentListingModel
}

export class AppointmentFlowLaneCard implements IAppointmentFlowLaneCard {
    @observable appointment: AppointmentListingModel;

    constructor(params: Partial<IAppointmentFlowLaneCard>) {
        const {
            appointment = AppointmentListingModel.getDefault(),
        } = params;

        this.appointment = appointment;

        makeObservable(this, undefined, { autoBind: true });
    }
}
